(function () {
    'use strict';
    var controllerId = 'pcAllievo2BAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', '$uibModal', 'datacontext', 'allievo', 'corsoId', 'opInsert', 'province', 'paesi', 'tIndirizzi', 'entiSubordinati', 'aplId', fn_pcAllievo2BAdd]);

    function fn_pcAllievo2BAdd($scope, $uibModalInstance, modal, datacontext, allievo, corsoId, opInsert, province, paesi, tIndirizzi, entiSubordinati, aplId) {
        //nascita
        $scope.province = province;
        $scope.paesi = paesi;
        $scope.comuni = [];
        //residenza
        $scope.province_res = province;
        $scope.paesi_res = paesi;
        $scope.comuni_res = [];
        $scope.tIndirizzi = tIndirizzi;
        //***
        $scope.entiSubordinati = entiSubordinati;
        $scope.aplId = aplId;


        $scope.validCF = true;
        $scope.checkCF = checkCF;

        if (allievo) {
            $scope.record = jQuery.extend({}, allievo); //Clona oggetto.
            $scope.Title = 'Modifica Allievo (ID: ' + $scope.record.Id + ')';
            if (typeof $scope.record.CodiceFiscale != 'undefined' && $scope.record.CodiceFiscale != null && $scope.record.CodiceFiscale.length > 0) {
                checkCF($scope.record.CodiceFiscale);
            }
            if (typeof $scope.record.PartitaIVA != 'undefined' && $scope.record.PartitaIVA != null && $scope.record.PartitaIVA.length > 0) {
                checkPIVA($scope.record.PartitaIVA);
            }
            if ($scope.record.NascProvinciaId > 0) {
                getComuni($scope.record.NascProvinciaId);
            }
            if ($scope.record.ResProvinciaId > 0) {
                getResComuni($scope.record.ResProvinciaId);
            }
            if ($scope.record.NascData != null) {
                $scope.record.NascData = new Date($scope.record.NascData);
            }
        }
        else {
            $scope.Title = 'Nuovo Allievo';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.CNDCorsoId = corsoId;
            $scope.record.OpInsert = opInsert;
            $scope.record.DtInsert = new Date();
            $scope.record.Deleted = false;
            $scope.record.iVersion = 1;

            $scope.record.NascComuneId = '';
            $scope.record.NascPaeseId = 0;

            $scope.record.ResComuneId = '';
            $scope.record.ResPaeseId = 0;
            $scope.record.ResTIndirizzoId = 1;
            $scope.record.DestinatarioId = 0;

            if ($scope.record.DestinatarioId == 0) {
                addDestMis2B();
            }
        }

        function addDestMis2B() {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi2B/modal/destMisura2BAdd.html?version=127',
                controller: 'destMisura2BAdd',
                backdrop: 'static',
                resolve: {
                }
            });
            modalInstance.result.then(function (returnItem) {
                if (returnItem) {
                    //console.info('addDestMis2B()', returnItem);
                    setDestinatarioInfo(returnItem);
                }
            }, function () {
                $uibModalInstance.dismiss('cancel');
            });
        }

        function setDestinatarioInfo(item) {
            $scope.record.DestinatarioId = item.Id;
            $scope.record.Nome = item.Nome;
            $scope.record.Cognome = item.Cognome;
            $scope.record.CodiceFiscale = item.CodiceFiscale;
            $scope.record.NascPaeseId = item.NascPaeseId;
            if (item.NascProvId > 0) {
                $scope.record.NascProvinciaId = item.NascProvId;
                getComuni($scope.record.NascProvinciaId);
            }
            $scope.record.NascComuneId = item.NascComuneId;
            if (item.NascData != null) {
                $scope.record.NascData = new Date(item.NascData);
            }
            $scope.record.ResPaeseId = item.Res_PaeseId;
            if (item.Res_ProvinciaId > 0) {
                $scope.record.ResProvinciaId = item.Res_ProvinciaId;
                getResComuni($scope.record.ResProvinciaId);
            }
            $scope.record.ResComuneId = item.Res_ComuneId;
            $scope.record.ResTIndirizzoId = item.Res_TIndirizzoId;
            $scope.record.ResIndirizzo = item.Res_Indirizzo;
            $scope.record.ResCivico = item.Res_Civico;
            $scope.record.ResCAP = item.Res_Cap;
        }

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            //return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            console.log('openCalendar');
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1) {
                console.log('iOpened == 1');
                $scope.opened1 = true;
            }

        };

        $scope.clear = function ($event, iOpened) {
            console.log('clear');
            if (iOpened == 1) {
                $scope.record.NascData = '';
                $scope.changed = true;
            }

        };

        $scope.format = "dd/MM/yyyy";



        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return item;
        }

        //nascita
        $scope.change_Paesi = function () {
            if ($scope.record.NascPaeseId > 0) {
                $scope.record.NascProvinciaId = 0;
                $scope.record.NascComuneId = 0;
            }
        };

        $scope.change_Comuni = function (idprov) {
            //console.info('change_Comuni()', idprov);
            $scope.record.NascComuneId = '';
            getComuni(idprov);
        };

        function getComuni(idprov) {
            //console.info('getComuni()', idprov);
            if (!idprov || idprov == 0) return $scope.comuni = [];

            if ($scope.record.NascProvinciaId != idprov)
                $scope.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni = data;
            });
        }

        //Residenza
        $scope.change_ResPaesi = function () {
            if ($scope.record.ResPaeseId > 0) {
                $scope.record.ResProvinciaId = 0;
                $scope.record.ResComuneId = 0;
            }
        };

        $scope.change_ResComuni = function (idprov) {
            //console.info('change_ResComuni()', idprov);
            $scope.record.ResComuneId = '';
            getResComuni(idprov);
        };

        function getResComuni(idprov) {
            //console.info('getResComuni()', idprov);
            if (!idprov || idprov == 0) return $scope.comuni_res = [];

            if ($scope.record.ResProvinciaId != idprov)
                $scope.comuni_res = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni_res = data;
            });
        }


        //Funzioni
        function checkCF(_value) {
            $scope.validCF = true;
            if (typeof _value == 'undefined') return;
            if (_value.length != 16) return;
            $scope.validCF = false;
            return datacontext.validazione_cf(_value, false).then(function (data) {
                return $scope.validCF = data;
            });
        }

        $scope.validEnteSub = true;
        $scope.change_enteSub = function () {
            $scope.validEnteSub = true;
            if ($scope.record.EnteId1 > 0 && $scope.record.EnteId1 == aplId) {
                $scope.validEnteSub = false;
            }

            /*
            if ($scope.record.EnteId2 > 0 && $scope.record.EnteId2 == aplId) {
                $scope.validEnteSub = false;
            }

            if ($scope.record.EnteId1 > 0 && $scope.record.EnteId2 > 0 && $scope.record.EnteId2 == $scope.record.EnteId1) {
                $scope.validEnteSub = false;
            }
            */

            return $scope.validEnteSub;
        }

    }
})();